import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, Grid, IconButton, InputLabel, Typography } from '@mui/material'
import ProgressBar from 'components/DataGrid/components/ProgressBar'
import DisplayChannels from 'components/DataGrid/DisplayChannels'

const ExpandDisplay = ({
  deal,
  organization,
  overallProgress,
  relatedProducts,
  launchOnboard,
  completedCounts,
  onClose,
}) => {
  return (
    <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
      <Grid item xs={3}>
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'left' }}>
          {organization?.name}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        {deal?.progress?.pct === 100 && deal?.onboardingStatus !== 'Launched' ? (
          <Button className="launch-onboard" sx={{ p: 0, color: 'text.success' }} onClick={launchOnboard}>
            Launch Onboard
          </Button>
        ) : deal?.progress?.pct === 100 && deal?.onboardingStatus === 'Launched' ? (
          <Typography sx={{ color: 'text.highlight' }}>Onboarding Completed</Typography>
        ) : deal?.onboardingStatus === 'Launched' ? (
          <Typography sx={{ color: 'text.warning' }}>Onboard Launched</Typography>
        ) : (
          <InputLabel>Onboarding Progress</InputLabel>
        )}
        <ProgressBar progress={overallProgress?.pct || deal?.progress?.pct || 0} />
      </Grid>
      <Grid item xs={5}>
        <Box sx={{ display: 'flex', gap: 0.8, width: '100%', justifyContent: 'flex-end' }}>
          <DisplayChannels deal={deal} products={relatedProducts} checklistProgress={completedCounts} />
        </Box>
      </Grid>
      <Grid item xs={1}>
        <IconButton onClick={onClose} sx={{ flex: '0 0 auto' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default ExpandDisplay
